export default class IndicatorsStartCtrl {
  constructor ($scope, $timeout, $stateParams, WorkPlanSrv, WorkPlanIndicatorSrv, $cookies) {
  
    const indicatorsVm = this

  //declaracion de variables
    indicatorsVm.type = $stateParams.indicatorType

  //variables para indicadores de tipo docencia
    indicatorsVm.percentEndPlaning   = 0
    indicatorsVm.percentReview   = 0
    indicatorsVm.percentPendingNewReview   = 0
    indicatorsVm.totalWorkPlans = 0
    indicatorsVm.numberEndPlaning = 0
    indicatorsVm.numberReview = 0
    indicatorsVm.numberPendingNewReview = 0

  //declaracion de funciones
    activate()

    function activate(){
      loadIndicators()          
    }


    function loadIndicators(){
      let params = {
        id_user: 1,
        is_review: 2,
        is_rejected: null
      }
      WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          
          if(dataReturn.data !== []){
            var index = 0
                indicatorsVm.percentEndPlaning   = 0
                indicatorsVm.percentReview   = 0
                indicatorsVm.percentPendingNewReview   = 0
                indicatorsVm.totalWorkPlans = 0
                indicatorsVm.numberEndPlaning = 0
                indicatorsVm.numberReview = 0
                indicatorsVm.numberPendingNewReview = 0
          }
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })

    }
  }
}

IndicatorsStartCtrl.$inject = ['$scope', '$timeout', '$stateParams', 
                          'WorkPlanSrv', 
                          'WorkPlanIndicatorSrv', '$cookies']





// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/indicatorsStart/indicatorsStartCtrl.js